import { Box, Button, Fade, useTheme } from '@mui/material';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import { FormattedMessage, useIntl } from 'react-intl';

import MuiTypography from '@mui/material/Typography';
import Dialog from 'components/dialog';
import CompareDialog from 'views/bluviu-nutrition/features/scenarios/components/view-results/compare-feed-programs/compare-dialog';
import { useScenarioResultState } from 'views/bluviu-nutrition/features/scenarios/context/scenario-result-context';

type Props = {
  showCompareBottomBar: boolean;
  clearSelection: () => void;
};

const ScenarioBottomBar: React.FC<Props> = ({ showCompareBottomBar, clearSelection }) => {
  const theme = useTheme();
  const intl = useIntl();
  const PAGE_NAME_ID = 'bluViuNutrition.viewScenarioResultGt2';

  const { selectedFeedPlans, selectedGraphData } = useScenarioResultState();

  return (
    <TrapFocus open={showCompareBottomBar} disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={showCompareBottomBar}>
        <Box
          p={10}
          display={showCompareBottomBar ? 'flex' : 'none'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'row'}
          sx={{
            background: theme.palette.darkBlue.o75,
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            height: 96,
            zIndex: 1300,
          }}>
          <Box marginRight={5} marginLeft={'auto'}>
            <MuiTypography color={'white'} variant="caption">
              {intl.formatMessage({ id: `${PAGE_NAME_ID}.selectedFeeds` }, { quantity: selectedFeedPlans.length | 0 })}
            </MuiTypography>
          </Box>
          <Box>
            <Dialog
              maxWidth="xl"
              titlePadding={5}
              sx={{ '& .MuiDialogContent-root': { padding: 5 } }}
              title={intl.formatMessage({ id: `${PAGE_NAME_ID}.compareDialog.compareDialogTitle` })}
              button={
                <Button>
                  <FormattedMessage id={`${PAGE_NAME_ID}.compareFeeds`} />
                </Button>
              }>
              <CompareDialog selectedGraphData={selectedGraphData} selectedFeedPlans={selectedFeedPlans} />
            </Dialog>
          </Box>
          <Box marginLeft={'auto'}>
            <Button
              sx={{
                backgroundColor: 'transparent',
                border: `1px solid ${theme.palette.common.white}`,
                color: `${theme.palette.common.white}`,
              }}
              onClick={() => clearSelection()}>
              <MuiTypography>
                <FormattedMessage id={`${PAGE_NAME_ID}.clear`} />
              </MuiTypography>
            </Button>
          </Box>
        </Box>
      </Fade>
    </TrapFocus>
  );
};

export default ScenarioBottomBar;
